import React from 'react';
import { Button } from 'bumbag';

import { Ugent } from '@medipass/react-core';
import { PAYMENT_PROVIDERS } from '@medipass/utils/constants';

import ApplePayButton from './ApplePayButton';
import GooglePayButton from './GooglePayButton';
interface ApproveRejectButtonsProps {
  enableApplePay?: boolean;
  enableGooglePay?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  onApplePayError?: (...args: Array<any>) => any;
  onApplePaySuccess?: (...args: Array<any>) => any;
  onClickExternalPayment?: (...args: Array<any>) => any;
  onClickReject?: (...args: Array<any>) => any;
  showReject?: boolean;
  transaction?: Record<string, any>;
  isSelectedPaymentExpired?: boolean;
}

export function ApproveRejectButtons({
  enableApplePay = true,
  enableGooglePay = true,
  isDisabled = false,
  isLoading = false,
  onApplePayError,
  onApplePaySuccess,
  onClickExternalPayment,
  onClickReject,
  showReject = false,
  transaction = undefined,
}: ApproveRejectButtonsProps) {
  return (
    <div className="space-y-2">
      {!enableGooglePay && !enableApplePay && (
        <Button
          palette="secondary"
          disabled={isDisabled || isLoading}
          isLoading={isLoading}
          size="medium"
          type="submit"
          width="100%"
        >
          APPROVE
        </Button>
      )}
      {onClickExternalPayment && (
        <React.Fragment>
          {enableGooglePay && (
            <Ugent browser="chrome">
              <GooglePayButton
                onClick={() =>
                  onClickExternalPayment({
                    paymentProvider: PAYMENT_PROVIDERS.GOOGLE_PAY,
                  })
                }
              />
            </Ugent>
          )}
          {transaction && enableApplePay && (
            <ApplePayButton
              amount={transaction.amountBalanceString}
              onError={onApplePayError}
              onSuccess={onApplePaySuccess}
            />
          )}
        </React.Fragment>
      )}
      {showReject && (
        <Button
          palette="danger"
          disabled={isLoading}
          size="medium"
          variant="outlined"
          onClick={onClickReject}
          width="100%"
        >
          REJECT
        </Button>
      )}
    </div>
  );
}
